import { IconName } from '@ardoq/icons';
import { StatusType } from '../types';
import type { InteractiveBadgeProps } from './types';
import {
  badgeBorderColors,
  badgeFills,
  badgeIconColors,
  badgeTextColors,
} from './brandColors';

export type BadgeStateColorMap = {
  color?: string;
  backgroundColor?: string;
  borderColor?: string;
  iconColor?: string;
};

export type BadgeColorMap = {
  default: BadgeStateColorMap;
};

const DEFAULT_BADGE_COLOR_MAP: BadgeColorMap = {
  default: {
    borderColor: badgeBorderColors[StatusType.DEFAULT],
    color: badgeTextColors[StatusType.DEFAULT],
    backgroundColor: badgeFills[StatusType.DEFAULT],
    iconColor: badgeIconColors[StatusType.DEFAULT],
  },
};

const SUCCESS_BADGE_COLOR_MAP: BadgeColorMap = {
  default: {
    borderColor: badgeBorderColors[StatusType.SUCCESS],
    color: badgeTextColors[StatusType.SUCCESS],
    backgroundColor: badgeFills[StatusType.SUCCESS],
    iconColor: badgeIconColors[StatusType.SUCCESS],
  },
};

const WARNING_BADGE_COLOR_MAP: BadgeColorMap = {
  default: {
    borderColor: badgeBorderColors[StatusType.WARNING],
    color: badgeTextColors[StatusType.WARNING],
    backgroundColor: badgeFills[StatusType.WARNING],
    iconColor: badgeIconColors[StatusType.WARNING],
  },
};

const ERROR_BADGE_COLOR_MAP: BadgeColorMap = {
  default: {
    borderColor: badgeBorderColors[StatusType.ERROR],
    color: badgeTextColors[StatusType.ERROR],
    backgroundColor: badgeFills[StatusType.ERROR],
    iconColor: badgeIconColors[StatusType.ERROR],
  },
};

const NEW_BADGE_COLOR_MAP: BadgeColorMap = {
  default: {
    borderColor: badgeBorderColors[StatusType.NEW],
    color: badgeTextColors[StatusType.NEW],
    backgroundColor: badgeFills[StatusType.NEW],
    iconColor: badgeIconColors[StatusType.NEW],
  },
};

const INFO_BADGE_COLOR_MAP: BadgeColorMap = {
  default: {
    borderColor: badgeBorderColors[StatusType.INFO],
    color: badgeTextColors[StatusType.INFO],
    backgroundColor: badgeFills[StatusType.INFO],
    iconColor: badgeIconColors[StatusType.INFO],
  },
};

const SCENARIO_BADGE_COLOR_MAP: BadgeColorMap = {
  default: {
    borderColor: badgeBorderColors[StatusType.SCENARIO],
    color: badgeTextColors[StatusType.SCENARIO],
    backgroundColor: badgeFills[StatusType.SCENARIO],
    iconColor: badgeIconColors[StatusType.SCENARIO],
  },
};

const BETA_BADGE_COLOR_MAP: BadgeColorMap = {
  default: {
    borderColor: badgeBorderColors[StatusType.BETA],
    color: badgeTextColors[StatusType.BETA],
    backgroundColor: badgeFills[StatusType.BETA],
    iconColor: badgeIconColors[StatusType.BETA],
  },
};

const TRIAL_BADGE_COLOR_MAP: BadgeColorMap = {
  default: {
    borderColor: badgeBorderColors[StatusType.TRIAL],
    color: badgeTextColors[StatusType.TRIAL],
    backgroundColor: badgeFills[StatusType.TRIAL],
    iconColor: badgeIconColors[StatusType.TRIAL],
  },
};

const WORKSPACE_BADGE_COLOR_MAP: BadgeColorMap = {
  default: {
    borderColor: badgeBorderColors[StatusType.WORKSPACE],
    color: badgeTextColors[StatusType.WORKSPACE],
    backgroundColor: badgeFills[StatusType.WORKSPACE],
    iconColor: badgeIconColors[StatusType.WORKSPACE],
  },
};

export const BADGE_COLOR_MAP: Record<StatusType, BadgeColorMap> = {
  [StatusType.DEFAULT]: DEFAULT_BADGE_COLOR_MAP,
  [StatusType.SUCCESS]: SUCCESS_BADGE_COLOR_MAP,
  [StatusType.WARNING]: WARNING_BADGE_COLOR_MAP,
  [StatusType.ERROR]: ERROR_BADGE_COLOR_MAP,
  [StatusType.NEW]: NEW_BADGE_COLOR_MAP,
  [StatusType.INFO]: INFO_BADGE_COLOR_MAP,
  [StatusType.SCENARIO]: SCENARIO_BADGE_COLOR_MAP,
  [StatusType.BETA]: BETA_BADGE_COLOR_MAP,
  [StatusType.TRIAL]: TRIAL_BADGE_COLOR_MAP,
  [StatusType.WORKSPACE]: WORKSPACE_BADGE_COLOR_MAP,
};

export const BADGE_ICON_MAP: Partial<Record<StatusType, IconName>> = {
  [StatusType.SUCCESS]: IconName.CHECK_CIRCLE,
  [StatusType.WARNING]: IconName.WARNING,
  [StatusType.ERROR]: IconName.ERROR,
  [StatusType.NEW]: IconName.NEW,
  [StatusType.INFO]: IconName.INFO,
  [StatusType.BETA]: IconName.BETA,
  [StatusType.TRIAL]: IconName.DEBT_ITEM,
};

export const BADGE_LABEL_MAP: Record<
  InteractiveBadgeProps['statusType'],
  string
> = {
  [StatusType.BETA]: 'Beta',
  [StatusType.NEW]: 'New',
  [StatusType.TRIAL]: 'Trial',
};
